module.exports = __webpack_public_path__ + "img/hc_pro_two_3.b278320b.jpg";